import { CommandScriptWidget } from '../../canvas/properties/CommandScriptWidget';
import { LockablePropertyStripLayout } from '../../canvas/properties/LockablePropertyStripLayout';
import { lockAndMoreLayout } from '../../canvas/properties/TextPropertyStripParts';
import { Button } from './Button';

export const buttonPropertyLayout = LockablePropertyStripLayout<Button>((d, s, o, w, a) => [
    //
    // Edit Text
    // w.createButton({
    //     name: 'editText',
    //     image: 'deqo://icons/i8/text',
    //     text: 'Edit Text',
    //     onAction() {
    //         d(togglePropertyStripMode);
    //     },
    // }),
    //
    // Macro
    w.createPopout({
        ui: CommandScriptWidget,
        value: a.get('commandScript'),
        image: 'deqo://icons/sln/04-programing-apps-websites/file-code',
        text: 'Macro',
        onSelect() {
            o.update(() => a.set('commandScript', this.value!));
        }
    }),
    //
    // Background
    w.createColorSelector({
        value: a.get('background'),
        text: 'Background Color',
        onSelect() {
            o.update(() => a.set('background', this.value!));
        }
    }),
    ...lockAndMoreLayout(d, s, o, w, a),
]);
